import type { RouteConfig } from '@/types';
import { Home, Blog, ArticleDetail, Effects, Demo, AdUI, ApiDocs, Chat, GroupChat, AdminLogin,Visualize, AdminWrite, AdminTags, AdminPhones, AdminArticles, InterviewQuestion,AdminInterviewManage, InterviewQuestionArticleDetail, AdminInterview,VR, Live2D, AdminSuggestion } from '@/pages';

export const routes: RouteConfig[] = [
  { path: '/', component: Home, exact: true, name: '首页', nav: true },
  { path: '/effects', component: Effects, exact: true, name: '特效', nav: true },
  { path: '/demo', component: Demo, exact: true, name: 'Demo', nav: true },
  { path: '/demo/chat', component: Chat, exact: true, name: 'AI 助手', nav: false },
  { path: '/demo/group-chat', component: GroupChat, exact: true, name: '群聊', nav: false },
  { path: '/demo/vr', component: VR, exact: true, name: 'VR全景看房', nav: false },
  { path: '/demo/visualize', component: Visualize, exact: true, name: '数据可视化', nav: false },
  { path: '/demo/live2d', component: Live2D, exact: true, name: 'Live2D看板娘', nav: false },
  { path: '/interview-question', component: InterviewQuestion, exact: true, name: '面试题', nav: true },
  { path: '/interview-question/article/:postsId', component: InterviewQuestionArticleDetail, exact: true, name: '文章详情', nav: false },
  { path: '/blog', component: Blog, exact: true, name: '学习笔记', nav: true },
  { path: '/blog/article/:postsId', component: ArticleDetail, exact: true, name: '文章详情', nav: false },
  { path: '/ad-ui', component: AdUI, exact: true, name: 'AdUI', nav: true },
  { path: '/docs', component: ApiDocs, exact: true, name: 'API文档', nav: true, auth: true },
  { path: '/admin/login', component: AdminLogin, exact: true, name: '登录', nav: false },
  { path: '/admin/write', component: AdminWrite, exact: true, name: '写文章', nav: false },
  { path: '/admin/interview', component: AdminInterview, exact: true, name: '面试题', nav: false },
  { path: '/admin/interview-manage', component: AdminInterviewManage, exact: true, name: '面试题管理', nav: false },
  { path: '/admin/tags', component: AdminTags, exact: true, name: '标签管理', nav: false },
  { path: '/admin/phones', component: AdminPhones, exact: true, name: '手机号管理', nav: false },
  { path: '/admin/suggestion', component: AdminSuggestion, exact: true, name: '建议管理', nav: false },
  { path: '/admin/articles', component: AdminArticles, exact: true, name: '文章管理', nav: false },
];

export const navItems = routes.filter((route) => route.nav);

export const defaultRoute = '/';
